import React, { useEffect, useState } from "react";
import "./usermanagement.scss";
import { useDispatch, useSelector } from "react-redux";
import { getAllUsers, activateDeactivateUser } from "../../../store/slices/authSlice";
// import toast from "react-hot-toast"; // Unused

export default function UserManagement() {
    const dispatch = useDispatch();
    const { users, usersLoading, totalUsers, currentPage, totalPages } = useSelector(
        (state) => state.auth
    );
    const [page, setPage] = useState(1);
    const limit = 10;

    useEffect(() => {
        dispatch(getAllUsers({ page, limit }));
    }, [dispatch, page]);

    const handleToggleActive = (userId, currentStatus) => {
        dispatch(
            activateDeactivateUser({
                user_id: userId,
                status: !currentStatus,
            })
        );
    };

    const formatDate = (dateString) => {
        if (!dateString) return "-";
        return new Date(dateString).toLocaleDateString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
        });
    };

    return (
        <div className="user-management-container">
            <div className="user-management-header">
                <h2>User Management</h2>
                <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                    <button
                        onClick={() => window.history.back()}
                        style={{
                            background: 'rgba(255, 255, 255, 0.1)',
                            border: '1px solid rgba(255, 255, 255, 0.2)',
                            color: '#fff',
                            padding: '6px 12px',
                            borderRadius: '6px',
                            cursor: 'pointer',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '5px',
                            fontSize: '14px'
                        }}
                    >
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M19 12H5M12 19l-7-7 7-7" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        Back
                    </button>
                    <p className="total-users">Total Users: {totalUsers}</p>
                </div>
            </div>

            {usersLoading ? (
                <div className="loading-state">Loading users...</div>
            ) : (
                <>
                    <div className="user-table-wrapper">
                        <table className="user-table">
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Email</th>
                                    <th>Role</th>
                                    <th>Verified</th>
                                    <th>Created</th>
                                    <th>Status</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {users?.length > 0 ? (
                                    users.map((user) => (
                                        <tr key={user.id}>
                                            <td>{user.name || "-"}</td>
                                            <td>{user.email}</td>
                                            <td>
                                                <span className={`role-badge ${user.role}`}>
                                                    {user.role || "user"}
                                                </span>
                                            </td>
                                            <td>
                                                <span className={`verified-badge ${user.is_verified ? "verified" : "unverified"}`}>
                                                    {user.is_verified ? "Yes" : "No"}
                                                </span>
                                            </td>
                                            <td>{formatDate(user.created_at)}</td>
                                            <td>
                                                <span className={`status-badge ${user.is_active ? "active" : "inactive"}`}>
                                                    {user.is_active ? "Active" : "Inactive"}
                                                </span>
                                            </td>
                                            <td>
                                                <button
                                                    className={`toggle-btn ${user.is_active ? "deactivate" : "activate"}`}
                                                    onClick={() => handleToggleActive(user.id, user.is_active)}
                                                    disabled={user.role === "admin"}
                                                    title={user.role === "admin" ? "Cannot modify admin user" : ""}
                                                >
                                                    {user.is_active ? "Deactivate" : "Activate"}
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="7" className="no-users">
                                            No users found
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    {totalPages > 1 && (
                        <div className="pagination">
                            <button
                                onClick={() => setPage((p) => Math.max(1, p - 1))}
                                disabled={currentPage === 1}
                                className="pagination-btn"
                            >
                                Previous
                            </button>
                            <span className="page-info">
                                Page {currentPage} of {totalPages}
                            </span>
                            <button
                                onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
                                disabled={currentPage === totalPages}
                                className="pagination-btn"
                            >
                                Next
                            </button>
                        </div>
                    )}
                </>
            )}
        </div>
    );
}
